<div class="m-[57px]">
  <h1 class="text-[32px] font-bold">
    Assessments
  </h1>
  <div class="mt-[23px] text-[14px] flex w-full">
    <button (click)="changeToOpenTab()" [ngClass]="assessmentTabStatus === AssessmentTabs.open? 'flex items-center px-[20px] py-[12px] border-b border-b-black rounded-t-[8px] hover:bg-gray-200':'flex items-center px-[20px] py-[12px] text-[#74808BB2] border-b border-b-[#74808BB2] rounded-t-[8px] hover:bg-gray-200'">
      @if (assessmentTabStatus !== AssessmentTabs.open) {
        <svg class="mr-[12px]" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M19.903 8.586C19.8555 8.4775 19.7892 8.37829 19.707 8.293L13.707 2.293C13.6217 2.21083 13.5225 2.14447 13.414 2.097C13.384 2.083 13.352 2.075 13.32 2.064C13.2363 2.03563 13.1492 2.01848 13.061 2.013C13.04 2.011 13.021 2 13 2H6C4.897 2 4 2.897 4 4V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V9C20 8.979 19.989 8.96 19.987 8.938C19.9815 8.84979 19.9644 8.7627 19.936 8.679C19.9267 8.647 19.9157 8.616 19.903 8.586ZM16.586 8H14V5.414L16.586 8ZM6 20V4H12V9C12 9.26522 12.1054 9.51957 12.2929 9.70711C12.4804 9.89464 12.7348 10 13 10H18L18.002 20H6Z" fill="#74808BB2"/>
          <path d="M8 12H16V14H8V12ZM8 16H16V18H8V16ZM8 8H10V10H8V8Z" fill="#121212"/>
        </svg>
      }
      @if (assessmentTabStatus === AssessmentTabs.open) {
        <svg class="mr-[12px]" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path d="M19.903 8.586C19.8555 8.4775 19.7892 8.37829 19.707 8.293L13.707 2.293C13.6217 2.21083 13.5225 2.14447 13.414 2.097C13.384 2.083 13.352 2.075 13.32 2.064C13.2363 2.03563 13.1492 2.01848 13.061 2.013C13.04 2.011 13.021 2 13 2H6C4.897 2 4 2.897 4 4V20C4 21.103 4.897 22 6 22H18C19.103 22 20 21.103 20 20V9C20 8.979 19.989 8.96 19.987 8.938C19.9815 8.84979 19.9644 8.7627 19.936 8.679C19.9267 8.647 19.9157 8.616 19.903 8.586ZM16.586 8H14V5.414L16.586 8ZM6 20V4H12V9C12 9.26522 12.1054 9.51957 12.2929 9.70711C12.4804 9.89464 12.7348 10 13 10H18L18.002 20H6Z" fill="#121212"/>
          <path d="M8 12H16V14H8V12ZM8 16H16V18H8V16ZM8 8H10V10H8V8Z" fill="#121212"/>
        </svg>
      }
      Open Assessments
    </button>
    <button (click)="changeToPastTab()" [ngClass]="assessmentTabStatus === AssessmentTabs.past? 'flex items-center px-[20px] py-[12px] border-b border-b-black rounded-t-[8px] hover:bg-gray-200':'flex items-center px-[20px] py-[12px] text-[#74808BB2] border-b border-b-[#74808BB2] rounded-t-[8px] hover:bg-gray-200'">
      @if (assessmentTabStatus !== AssessmentTabs.past) {
        <svg class="mr-[12px]" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
          <path d="M13 0L8 3L13 6V4C17.955 4 22 8.045 22 13C22 17.955 17.955 22 13 22C8.045 22 4 17.955 4 13C4 10.547 4.883 8.43 6.5 6.812L5.094 5.407C3.11 7.39 2 10.053 2 13C2 19.045 6.955 24 13 24C19.045 24 24 19.045 24 13C24 6.955 19.045 2 13 2V0ZM10.906 6.563L9.094 7.438L11.625 12.438C11.5474 12.6155 11.505 12.8064 11.5 13V13.063L8.281 16.28L9.72 17.72L12.939 14.501H13C13.3978 14.501 13.7794 14.343 14.0607 14.0617C14.342 13.7804 14.5 13.3988 14.5 13.001C14.5 12.311 14.041 11.738 13.406 11.563L10.906 6.563Z" fill="#74808BB2"/>
        </svg>
      }
      @if (assessmentTabStatus === AssessmentTabs.past) {
        <svg class="mr-[12px]" xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
          <path d="M13 0L8 3L13 6V4C17.955 4 22 8.045 22 13C22 17.955 17.955 22 13 22C8.045 22 4 17.955 4 13C4 10.547 4.883 8.43 6.5 6.812L5.094 5.407C3.11 7.39 2 10.053 2 13C2 19.045 6.955 24 13 24C19.045 24 24 19.045 24 13C24 6.955 19.045 2 13 2V0ZM10.906 6.563L9.094 7.438L11.625 12.438C11.5474 12.6155 11.505 12.8064 11.5 13V13.063L8.281 16.28L9.72 17.72L12.939 14.501H13C13.3978 14.501 13.7794 14.343 14.0607 14.0617C14.342 13.7804 14.5 13.3988 14.5 13.001C14.5 12.311 14.041 11.738 13.406 11.563L10.906 6.563Z" fill="#121212"/>
        </svg>
      }
      Past Assessments
    </button>
    <!--<button (click)="assessmentTabStatus = AssessmentTabs.practice" [ngClass]="assessmentTabStatus === AssessmentTabs.practice? 'flex items-center px-[20px] py-[12px] border-b border-b-black rounded-t-[8px] hover:bg-gray-200':'flex items-center px-[20px] py-[12px] text-[#74808BB2] border-b border-b-[#74808BB2] rounded-t-[8px] hover:bg-gray-200'">
      @if (assessmentTabStatus !== AssessmentTabs.practice) {
        <svg class="mr-[12px]" xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
          <path d="M1 7C1 4.172 1 2.757 1.879 1.879C2.757 1 4.172 1 7 1H11C13.828 1 15.243 1 16.121 1.879C17 2.757 17 4.172 17 7V15C17 17.828 17 19.243 16.121 20.121C15.243 21 13.828 21 11 21H7C4.172 21 2.757 21 1.879 20.121C1 19.243 1 17.828 1 15V7Z" stroke="#74808BB2" stroke-width="1.5"/>
          <path d="M16.898 15H4.898C3.968 15 3.503 15 3.121 15.102C2.61231 15.2384 2.14849 15.5063 1.77618 15.8788C1.40386 16.2513 1.13616 16.7152 1 17.224" stroke="#74808BB2" stroke-width="1.5"/>
          <path d="M5 6H13M5 9.5H10" stroke="#74808BB2" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      }
      @if (assessmentTabStatus === AssessmentTabs.practice) {
        <svg class="mr-[12px]" xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
          <path d="M1 7C1 4.172 1 2.757 1.879 1.879C2.757 1 4.172 1 7 1H11C13.828 1 15.243 1 16.121 1.879C17 2.757 17 4.172 17 7V15C17 17.828 17 19.243 16.121 20.121C15.243 21 13.828 21 11 21H7C4.172 21 2.757 21 1.879 20.121C1 19.243 1 17.828 1 15V7Z" stroke="#121212" stroke-width="1.5"/>
          <path d="M16.898 15H4.898C3.968 15 3.503 15 3.121 15.102C2.61231 15.2384 2.14849 15.5063 1.77618 15.8788C1.40386 16.2513 1.13616 16.7152 1 17.224" stroke="#121212" stroke-width="1.5"/>
          <path d="M5 6H13M5 9.5H10" stroke="#121212" stroke-width="1.5" stroke-linecap="round"/>
        </svg>
      }
      Practices
    </button>-->
    <div class="grow border-b-[#74808BB2] border-b"></div>
  </div>
  <div class="mt-[40px] flex justify-between">
    <div class="flex items-center text-[16px]">
      <div class="font-semibold mr-[12px]">
        Assessment Type:
      </div>
      <div>
        <button (click)="showAssessmentTypeDropdown = !showAssessmentTypeDropdown" class="flex justify-between border rounded-[8px] border-[#BFC7CE] bg-[#FFF] px-[18px] py-[12px] w-[196px] hover:border-[#718293] hover:bg-[#D6DBE0]">
          {{assessmentTypeSelected}}
          <fa-icon [icon]="faChevronDown" />
        </button>
        @if (showAssessmentTypeDropdown) {
          <div class="assessmentTypeDropdown">
            <button (click)="switchAssessmentTypeSelected(AssessmentTypes.all_types)" class="hover:bg-[#FBEBEF] w-full flex items-center py-[6px] pl-[12px] group">
              <checkbox-circle [checked]="assessmentTypeSelected === AssessmentTypes.all_types" />
              {{AssessmentTypes.all_types}}
            </button>
            <button (click)="switchAssessmentTypeSelected(AssessmentTypes.exam)" class="hover:bg-[#FBEBEF] w-full flex items-center py-[6px] pl-[12px] group">
              <checkbox-circle [checked]="assessmentTypeSelected === AssessmentTypes.exam" />
              {{AssessmentTypes.exam}}
            </button>
            <button (click)="switchAssessmentTypeSelected(AssessmentTypes.quiz)" class="hover:bg-[#FBEBEF] w-full flex items-center py-[6px] pl-[12px] group">
              <checkbox-circle [checked]="assessmentTypeSelected === AssessmentTypes.quiz" />
              {{AssessmentTypes.quiz}}
            </button>
            <button (click)="switchAssessmentTypeSelected(AssessmentTypes.homework)" class="hover:bg-[#FBEBEF] w-full flex items-center py-[6px] pl-[12px] group">
              <checkbox-circle [checked]="assessmentTypeSelected === AssessmentTypes.homework" />
              {{AssessmentTypes.homework}}
            </button>
          </div>
        }
      </div>
    </div>
    <div class="bg-[#FFF] w-[267px] h-[48px] flex items-center border border-[#BFC7CE] rounded-[8px]">
      <fa-icon [icon]="faMagnifyingGlass" class="mr-[12px] ml-[18px]" />
      <input (ngModelChange)="debounceSearch()" class=".placeholder-[#586674] bg-transparent !outline-none flex-grow h-full" [(ngModel)]="searchText" placeholder="Search" />
    </div>
  </div>
  <div class="mt-[38px] bg-[#F4F6F8] rounded-[4px] grid grid-cols-5 h-[48px] px-[16px] text-[14px] text-[#666E7D] font-bold">
    <div class="flex items-center ml-[48px] text-gray-500 text-sm font-semibold font-['Inter']">
      Title
    </div>
    <div class="flex items-center text-gray-500 text-sm font-semibold font-['Inter']">
      Type
    </div>
    <div class="flex items-center text-gray-500 text-sm font-semibold font-['Inter']">
      Status
    </div>
    <div class="flex items-center text-gray-500 text-sm font-semibold font-['Inter']">
      Due Date
    </div>
    <div>
    </div>
  </div>
  @for (exam of assessments; track exam; let i = $index) {
    <div>
      <div [ngClass]="i%2 ===0? 'rounded-[4px] grid grid-cols-5 px-[16px] text-[14px] text-[#666E7D] py-[8px]':'bg-[#F4F6F8] rounded-[4px] grid grid-cols-5 px-[16px] text-[14px] text-[#666E7D] py-[8px]'">
        <div class="flex items-center ml-[48px]">
          {{ exam.exam_title }}
        </div>
        <div class="flex items-center">
          {{ exam.type }}
        </div>
        <div class="flex items-center w-[140px]">
          <ExamStatusComponent [exam]="exam" [fixedWidth]="140" />
        </div>
        <div class="flex items-center">
          <div class="flex flex-col justify-center">
            {{ exam.due_time | date: 'dd MMM, yyyy'}}
            <div [ngClass]="getDaysRemaining(exam.due_time) > 1? 'text-[12px] text-[#637381] mt-[4px]':'text-[12px] text-[#CC0033] mt-[4px]'">
              {{getDaysRemaining(exam.due_time)}} day(s) left
            </div>
          </div>
        </div>
        <div>
          @if (exam.status === 'not_started') {
            <button class="px-[20px] py-[10px] rounded-[8px] bg-[#CC0033] text-white w-[140px] text-[14px] hover:bg-[#940025]">
              Start
            </button>
          }
          @if (exam.status !== 'not_started' && exam.status !== 'scored' && exam.status !== 'past_due') {
            <button disabled class="px-[20px] py-[10px] rounded-[8px] bg-[#FF4775] text-white w-[140px] text-[14px]">
              No Action
            </button>
          }
          @if(exam.status === 'past_due') {
            <button disabled class="px-[20px] py-[10px] rounded-[8px] bg-[#FF4775] text-white w-[140px] text-[14px]">
              Past Due
            </button>
          }
          @if (exam.status === 'scored') {
            <button class="px-[20px] py-[10px] rounded-[8px] hover:bg-[#F2EFFE] border hover:border-[#940025] hover:text-[#940025] border-[#C03] text-[#C03] w-[140px] text-[14px]">
              View Score
            </button>
          }
        </div>
      </div>
    </div>
  }
  <full-length-pagination [(currentPagination)]="currentPagination" />
</div>
